// extracted by mini-css-extract-plugin
export default {"room":"Room_room__OARmF","gif":"Room_gif__70Hmy","alarm":"Room_alarm__xJOki","active-sensor":"Room_active-sensor__GpWXk","hidden":"Room_hidden__xi5LQ"};